/* Starqon "Load more" — koleksiyon ızgarası (§115, 2026-10-03). Bağımlılıksız, defer; main-collection-product-grid.liquid yükler.
   AŞAMALI GELİŞTİRME: Liquid normal sayfalamayı (<nav class="pagination">) <starqon-load-more> içine koyar. Bu dosya yüklenmez/çalışmazsa
   "1 2 ›" bağlantıları aynen çalışır. Çalışınca: sayfalama gizlenir, "Load more" + "Showing X of Y" görünür.
   Akış: sonraki sayfa = pagination'daki rel="next" href (filtre/sıralama parametreleri onda zaten var) → Section Rendering API ile yalnız bu
   bölüm çekilir → ızgara öğeleri eklenir → URL history.replaceState ile ?page=N olur (yenileme/paylaşma o sayfayı açar; 2+. sayfada açılırsa
   Liquid "Show previous products" bağlantısı basar, burada önceki sayfa ızgaranın başına eklenir). Hata olursa normal gezinmeye düşer.
   facets.js: filtre/sıralama değişince #ProductGridContainer'ın innerHTML'ini yeniden yazar → eski öğe disconnectedCallback (istek iptal),
   yeni öğe connectedCallback ile 1. sayfanın durumundan yeniden kurulur. facets.js'in popstate/pushState akışına dokunulmaz (state korunur).
   Hareket: eklenen kartlar §103 belirme dilinde (.sq-rv → .sq-in, yalnız transform/opacity, bir kez); prefers-reduced-motion'da yok. */
(function () {
  if (!window.customElements || customElements.get('starqon-load-more')) return;
  var sakin = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function temiz(href) {
    var u = new URL(href, location.href);
    u.searchParams.delete('section_id'); /* bölüm yanıtındaki bağlantılarda kalabilir; adres çubuğuna/gezinmeye taşınmasın */
    return u;
  }
  /* rel="next"/"prev" (§115 pagination.liquid). Eski işaretlemede Dawn'ın ters adlı okları: --prev = sonraki, --next = önceki */
  function bag(kok, yon) {
    var a = kok.querySelector('.pagination a[rel="' + yon + '"]') ||
      kok.querySelector(yon === 'next' ? '.pagination a.pagination__item--prev' : '.pagination a.pagination__item--next');
    return a && a.getAttribute('href') ? temiz(a.getAttribute('href')).href : null;
  }

  class SqLoadMore extends HTMLElement {
    connectedCallback() {
      this.kap = this.closest('.collection');
      this.grid = this.kap && this.kap.querySelector('#product-grid');
      this.ui = this.querySelector('.sq-lm__ui');
      this.btn = this.querySelector('[data-sq-lm-more]');
      this.durum = this.querySelector('.sq-lm__status');
      this.cubuk = this.querySelector('.sq-lm__bar i');
      this.sayfalama = this.querySelector('.pagination-wrapper');
      if (!this.grid || !this.ui || !this.btn || !this.sayfalama || !this.dataset.sectionId) return; /* beklenmeyen işaretleme: sayfalama kalır */
      this.sonraki = bag(this.sayfalama, 'next');
      this.onceki = bag(this.sayfalama, 'prev');
      this.geri = this.kap.querySelector('[data-sq-lm-prev]');
      this.sayfalama.hidden = true;
      this.ui.hidden = false;
      this.btn.addEventListener('click', (e) => this.yukle('next', e));
      if (this.geri) this.geri.addEventListener('click', (e) => { e.preventDefault(); this.yukle('prev', e); });
      this.guncelle();
    }

    disconnectedCallback() {
      if (this.ctrl) this.ctrl.abort();
      if (this.io) this.io.disconnect();
    }

    guncelle() {
      var adet = this.grid.querySelectorAll(':scope > .grid__item').length;
      var top = parseInt(this.dataset.total, 10) || adet;
      if (this.durum && this.dataset.status) this.durum.textContent = this.dataset.status.replace('[shown]', adet);
      if (this.cubuk) this.cubuk.style.setProperty('--sq-lm-p', Math.min(1, adet / top).toFixed(4));
      this.btn.hidden = !this.sonraki;
      if (this.geri && this.geri.parentElement) this.geri.parentElement.hidden = !this.onceki;
    }

    async yukle(yon, e) {
      var hedef = yon === 'next' ? this.sonraki : this.onceki;
      if (this.mesgul || !hedef) return;
      this.mesgul = true;
      var klavye = e && e.detail === 0; /* klavye / ekran okuyucu ile etkinleştirme → odak yeni ilk karta taşınır */
      var url = temiz(hedef);
      var istek = new URL(url.href);
      istek.searchParams.set('section_id', this.dataset.sectionId);
      var dugme = yon === 'next' ? this.btn : this.geri;
      var etiket = dugme.textContent;
      dugme.setAttribute('aria-busy', 'true');
      if (yon === 'next' && this.dataset.loading) dugme.textContent = this.dataset.loading;
      var y0 = yon === 'prev' ? this.geri.getBoundingClientRect().top : 0;
      this.ctrl = new AbortController();
      try {
        var yanit = await fetch(istek.href, { signal: this.ctrl.signal, credentials: 'same-origin' });
        if (!yanit.ok) throw new Error('HTTP ' + yanit.status);
        var doc = new DOMParser().parseFromString(await yanit.text(), 'text/html');
        if (!this.isConnected) return; /* bu arada facets.js ızgarayı yeniden yazdı */
        var yeniGrid = doc.getElementById('product-grid');
        if (!yeniGrid) throw new Error('grid yok');
        /* aynı ürün iki kez gelmesin (sayfalar arası sıralama kayması) */
        var yeni = Array.prototype.filter.call(yeniGrid.querySelectorAll(':scope > .grid__item'), function (li) {
          var a = li.querySelector('a[id^="CardLink-"]');
          return !(a && document.getElementById(a.id));
        });
        var oynat = !sakin && 'IntersectionObserver' in window;
        var parca = document.createDocumentFragment();
        yeni.forEach(function (li) { if (oynat) li.classList.add('sq-rv'); parca.appendChild(li); });
        if (yon === 'next') {
          this.grid.appendChild(parca);
          this.sonraki = bag(doc, 'next');
          history.replaceState(history.state, '', url.pathname + url.search + location.hash);
        } else {
          this.grid.insertBefore(parca, this.grid.firstChild);
          this.onceki = bag(doc, 'prev');
        }
        this.guncelle();
        if (yon === 'prev' && yeni.length) {
          /* yeni kartlar tıklanan bağlantının yerinde başlasın (tarayıcının kaydırma çapası farkı ne olursa olsun) */
          var tutamak = this.geri && !this.geri.parentElement.hidden ? this.geri : yeni[0];
          window.scrollBy(0, tutamak.getBoundingClientRect().top - y0);
        }
        if (oynat) this.belirt(yeni);
        /* önbellekten anında gelen tembel görseller (theme.liquid load dinleyicisinin yedeği) */
        yeni.forEach(function (li) {
          li.querySelectorAll('img').forEach(function (img) { if (img.complete && img.naturalWidth) img.classList.add('sq-in'); });
        });
        if (klavye && yeni[0]) {
          var link = yeni[0].querySelector('a[id^="CardLink-"]') || yeni[0].querySelector('a[href]');
          if (link) link.focus();
        }
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        location.assign(url.href); /* yedek: JS'siz davranış — o sayfaya normal git */
        return;
      } finally {
        if (dugme) { dugme.removeAttribute('aria-busy'); if (yon === 'next') dugme.textContent = etiket; }
        this.mesgul = false;
      }
    }

    belirt(liste) {
      var self = this;
      if (!this.io) {
        this.io = new IntersectionObserver(function (es) {
          var k = 0;
          es.forEach(function (x) {
            if (!x.isIntersecting) return;
            x.target.style.setProperty('--sq-i', Math.min(k++, 5));
            x.target.classList.add('sq-in');
            self.io.unobserve(x.target);
          });
        }, { rootMargin: '0px 0px -6% 0px' });
      }
      liste.forEach(function (li) { self.io.observe(li); });
    }
  }

  customElements.define('starqon-load-more', SqLoadMore);
})();
